import { render, staticRenderFns } from "./ExamPackage.vue?vue&type=template&id=70411467&scoped=true"
import script from "./ExamPackage.vue?vue&type=script&lang=js"
export * from "./ExamPackage.vue?vue&type=script&lang=js"
import style0 from "./ExamPackage.vue?vue&type=style&index=0&id=70411467&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70411467",
  null
  
)

export default component.exports